/*** Importations **********************************************************************************************/

// Polyfills
import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';


// Libraries
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Choices from 'choices.js';
// import html2canvas from 'html2canvas';


// Scripts Nubee
import * as functions from 'partials/functions.js';
// import * as fireworks from 'partials/fireworks.js';
import placeholderLabelUpdate from 'partials/placeholder-label.js';
import imgCheck from 'partials/img-check.js';
import FormValidation from 'partials/form-validation.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	/*** Variables globales ************************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de bones : window.bonesGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();

	/*** Afficher la page d'accueil en étape *******************************************************************/
	(function() {

		window.addEventListener("load", function(){
			let montage_full = document.getElementById('montage-cornet'),
				montage = montage_full.querySelector('.montage'),
				ingredients = montage_full.querySelectorAll('.ingredient');

			setTimeout(function() {
				montage.style.opacity = 1;

				setTimeout(function() {
					ingredients.forEach( function( thisIngredient ) {
						thisIngredient.style.opacity = 1;
					} );
				}, 1500 );
			}, 2500 );

			// Tester si les WebP sont supportés et mettre les fallback png sinon
			var webp = new Image();
	
			webp.onerror = function(){
				document.querySelectorAll('.flavors-slider .pellet img').forEach( function( thisImg ){
					thisImg.setAttribute( 'src', thisImg.dataset.fallback );
				} );

				document.querySelectorAll('.flavors-slider .cone img').forEach( function( thisImg ){
					thisImg.setAttribute( 'src', thisImg.dataset.fallback );
				} );
			};
	
			webp.src = 'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoBAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==';
		});

	}) ();

	/*** Binder Choice sur les select **************************************************************************/
	(function() {
		let storeList = document.getElementById( 'store-list' );

		const choices = new Choices(storeList, {
			loadingText: window.bonesGlobals.i18n.selectChoice.loading,
			noResultsText: window.bonesGlobals.i18n.selectChoice.noResults,
			noChoicesText: window.bonesGlobals.i18n.selectChoice.noChoices,
			itemSelectText: window.bonesGlobals.i18n.selectChoice.itemSelect,

			placeholder: true,
			placeholderValue: window.bonesGlobals.i18n.selectChoice.placeholder,
			searchPlaceholderValue: window.bonesGlobals.i18n.selectChoice.search,

			searchEnabled: true,
			searchChoices: true,
			searchFloor: 1,
			searchResultLimit: 5,
			searchFields: ['label', 'value']
		});

	}) ();

	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *********************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');
		// let appPage = document.querySelectorAll('.app-page');

		linksWithHash.forEach( function( thisEl ) {
			thisEl.addEventListener( 'click', function() {
				// Get active page and hide it
				// let nextPageID = thisEl.hash.substr(1);

				functions.showNextPage( thisEl.hash.substr(1) );
			});
		});
	}) ();

	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran *******************************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();

	/*** Validation de formulaire ******************************************************************************/
	(function() {
		// document.querySelectorAll( '.validate-form' ).forEach( function( thisForm ) {
		// 	if( functions.scriptsOk( thisForm ) ) {
				new FormValidation({
					form: document.getElementById('form-participation'),
					// debug: true,
				});
		// 	}
		// } );
	}) ();


	/*** Placeholder labels - Un placeholder qui se tasse quand on écrit ***************************************/
	// Requiert la classe sweet-form sur le formulaire
	// Requiert placeholder-label.js

	(function() {
		document.querySelectorAll('.has-placeholder-label input, .has-placeholder-label textarea').forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				placeholderLabelUpdate( thisEl );

				[ 'load', 'focus', 'blur', 'change', 'input' ].forEach( function( eventName ) {
					thisEl.addEventListener( eventName, placeholderLabelUpdate );
				} );
			}
		} );
	}) ();


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ************************/
	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();

}) ();